export default __webpack_public_path__ + "static/media/vertical-dark.d1426ca9.svg";